document.documentElement.classList.remove('no-js');

function updateDisplayedPrice(source) {
  if (!source?.dataset?.price && !source?.dataset?.bundlePrice) return;
  const price = source.dataset.bundlePrice || source.dataset.price;
  const comparePrice = source.dataset.comparePrice || '';
  const saveLabel = source.dataset.saveLabel || '';
  document.querySelectorAll('[data-current-price]').forEach((element) => { element.textContent = price; });
  document.querySelectorAll('[data-price] [data-compare-price]').forEach((element) => { element.textContent = comparePrice; element.hidden = !comparePrice; });
  document.querySelectorAll('[data-price] [data-save-badge]').forEach((element) => { element.textContent = saveLabel; element.hidden = !saveLabel; });
}

class DemandCounter extends HTMLElement {
  connectedCallback() {
    this.output = this.querySelector('[data-demand-count]');
    if (!this.output) return;
    const configuredCount = Number(this.dataset.startingCount);
    const startingCount = Number.isFinite(configuredCount) ? configuredCount : 0;
    this.count = this.readSavedCount(startingCount);
    this.sequenceStep = 0;
    this.render();
    this.persist();
    this.scheduleNextIncrement();
  }
  disconnectedCallback() {
    window.clearTimeout(this.incrementTimeout);
  }
  readSavedCount(fallback) {
    try {
      const match = document.cookie.match(/(?:^|;\s*)spookyseatLiveDemandCount=([^;]*)/);
      if (!match) return fallback;
      const savedCount = Number(decodeURIComponent(match[1]));
      return Number.isInteger(savedCount) && savedCount >= 0 ? savedCount : fallback;
    } catch (_error) {
      return fallback;
    }
  }
  persist() {
    try {
      document.cookie = `spookyseatLiveDemandCount=${encodeURIComponent(this.count)}; Max-Age=2592000; Path=/; SameSite=Lax`;
    } catch (_error) {
      // The visible counter still works when browser privacy settings block cookies.
    }
  }
  render() {
    this.output.textContent = String(this.count);
  }
  increment(amount = 1) {
    this.count += amount;
    this.render();
    this.persist();
  }
  scheduleNextIncrement() {
    const openingSequence = [
      { delay: 1600, amount: 1 },
      { delay: 3000, amount: 2 },
      { delay: 6000, amount: 1 }
    ];
    const next = openingSequence[this.sequenceStep] || { delay: 1000 + Math.floor(Math.random() * 29001), amount: 1 };
    this.incrementTimeout = window.setTimeout(() => {
      this.increment(next.amount);
      this.sequenceStep += 1;
      this.scheduleNextIncrement();
    }, next.delay);
  }
}

class ProductGallery extends HTMLElement {
  connectedCallback() {
    this.querySelectorAll('[data-media-target]').forEach((button) => button.addEventListener('click', () => this.show(button)));
  }
  show(button) {
    const id = button.dataset.mediaTarget;
    this.querySelectorAll('[data-media-id]').forEach((media) => {
      const active = media.dataset.mediaId === id;
      media.hidden = !active;
      media.classList.toggle('is-active', active);
    });
    this.querySelectorAll('[data-media-target]').forEach((thumb) => thumb.classList.toggle('is-active', thumb === button));
  }
}

class BundlePicker extends HTMLElement {
  connectedCallback() {
    this.quantity = this.querySelector('[data-quantity]');
    this.bundleDiscount = this.querySelector('[data-bundle-discount]');
    this.bundleLabel = this.querySelector('[data-bundle-label]');
    this.querySelectorAll('[data-bundle-quantity], [data-variant-id]').forEach((button) => button.addEventListener('click', () => this.choose(button)));
    this.startTimedOffer();
    this.observeForStickyBuy();
    const selected = this.querySelector('.bundle-card.is-selected');
    if (selected) this.choose(selected);
  }
  disconnectedCallback() {
    window.clearInterval(this.timerInterval);
    this.stickyObserver?.disconnect();
    window.removeEventListener('scroll', this.updateStickyVisibility);
    window.removeEventListener('resize', this.updateStickyVisibility);
  }
  startTimedOffer() {
    this.doubleOffer = this.querySelector('[data-offer-id="double"]');
    if (!this.doubleOffer) return;
    const minutes = Number(this.dataset.timedOfferMinutes || 10);
    const storageKey = `spookyseatTimedOffer:${this.dataset.sectionId || 'product'}`;
    let endTime = 0;
    try {
      endTime = Number(localStorage.getItem(storageKey));
      if (!endTime) {
        endTime = Date.now() + minutes * 60 * 1000;
        localStorage.setItem(storageKey, String(endTime));
      }
    } catch (_error) {
      endTime = Date.now() + minutes * 60 * 1000;
    }
    this.offerEndTime = endTime;
    this.updateTimedOffer();
    this.timerInterval = window.setInterval(() => this.updateTimedOffer(), 1000);
  }
  updateTimedOffer() {
    const remaining = Math.max(0, this.offerEndTime - Date.now());
    const totalSeconds = Math.ceil(remaining / 1000);
    const minutes = Math.floor(totalSeconds / 60);
    const seconds = String(totalSeconds % 60).padStart(2, '0');
    const section = this.closest('.product-section') || document;
    section.querySelectorAll('[data-offer-timer]').forEach((timer) => { timer.textContent = remaining > 0 ? `${minutes}:${seconds}` : 'Offer ended'; });
    if (remaining > 0 || this.doubleOffer.dataset.offerExpired === 'true') return;
    this.doubleOffer.dataset.offerExpired = 'true';
    this.doubleOffer.dataset.bundlePrice = this.doubleOffer.dataset.expiredPrice;
    this.doubleOffer.dataset.comparePrice = '';
    this.doubleOffer.dataset.bundleDiscountCode = '';
    this.doubleOffer.dataset.saveLabel = '$30 Savings';
    const currentPrice = this.doubleOffer.querySelector('[data-offer-current-price]');
    const comparePrice = this.doubleOffer.querySelector('[data-offer-compare-price]');
    if (currentPrice) currentPrice.textContent = this.doubleOffer.dataset.expiredPrice;
    if (comparePrice) comparePrice.hidden = true;
    section.querySelectorAll('[data-sticky-sale-price]').forEach((node) => { node.textContent = this.doubleOffer.dataset.expiredPrice; });
    section.querySelectorAll('[data-sticky-original-price]').forEach((node) => { node.hidden = true; });
    section.querySelectorAll('[data-sticky-save-label]').forEach((node) => { node.textContent = 'Timed offer ended'; });
    section.querySelectorAll('[data-sticky-submit]').forEach((node) => { node.textContent = 'Buy Now'; });
    if (this.doubleOffer.classList.contains('is-selected')) this.choose(this.doubleOffer);
  }
  observeForStickyBuy() {
    const sticky = this.closest('.product-section')?.querySelector('[data-sticky-buy]');
    if (!sticky) return;
    this.updateStickyVisibility = () => {
      sticky.hidden = !(this.getBoundingClientRect().bottom < window.innerHeight * 0.65);
    };
    window.addEventListener('scroll', this.updateStickyVisibility, { passive: true });
    window.addEventListener('resize', this.updateStickyVisibility);
    this.updateStickyVisibility();
  }
  choose(button) {
    if (button.dataset.bundleQuantity && this.quantity) this.quantity.value = button.dataset.bundleQuantity;
    if (this.bundleDiscount) this.bundleDiscount.value = button.dataset.bundleDiscountCode || '';
    if (this.bundleLabel) this.bundleLabel.value = button.dataset.cartLabel || '';
    updateDisplayedPrice(button);
    if (button.dataset.variantId) {
      const form = this.closest('form');
      const variantInput = form?.querySelector('input[data-variant-id]');
      const variantSelect = form?.querySelector('[data-variant-select]');
      if (variantInput) variantInput.value = button.dataset.variantId;
      if (variantSelect) {
        variantSelect.value = button.dataset.variantId;
        variantSelect.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }
    this.querySelectorAll('[data-bundle-quantity], button[data-variant-id]').forEach((option) => {
      const selected = option === button;
      option.classList.toggle('is-selected', selected);
      option.setAttribute('aria-pressed', String(selected));
    });
  }
}

class ProductForm extends HTMLElement {
  connectedCallback() {
    this.form = this.querySelector('form');
    this.status = this.querySelector('[data-product-status]');
    this.button = this.querySelector('[data-add-to-cart]');
    this.variantInput = this.querySelector('[data-variant-id]');
    this.variantSelect = this.querySelector('[data-variant-select]');
    this.bundleDiscount = this.querySelector('[data-bundle-discount]');
    this.bundleLabel = this.querySelector('[data-bundle-label]');
    this.form?.addEventListener('submit', (event) => this.submit(event));
    this.variantSelect?.addEventListener('change', () => this.changeVariant());
    const sticky = this.closest('.product-section')?.querySelector('[data-sticky-buy]');
    this.sticky = sticky;
    sticky?.querySelector('[data-sticky-submit]')?.addEventListener('click', () => {
      const picker = this.querySelector('bundle-picker');
      const doubleOffer = picker?.querySelector('[data-offer-id="double"]');
      if (picker && doubleOffer) picker.choose(doubleOffer);
      this.form.requestSubmit();
    });
  }
  changeVariant() {
    const option = this.variantSelect.selectedOptions[0];
    this.variantInput.value = option.value;
    updateDisplayedPrice(option);
    this.button.disabled = option.dataset.available !== 'true';
    this.button.querySelector('[data-button-text]').textContent = this.button.disabled ? 'Sold out' : 'Add to cart';
  }
  async submit(event) {
    event.preventDefault();
    this.button.disabled = true;
    this.status.classList.remove('is-error');
    this.status.textContent = 'Adding your scare…';
    const quantity = Number(this.form.querySelector('[data-quantity]').value || 1);
    const bundleLabel = this.bundleLabel?.value.trim();
    const items = [{ id: Number(this.variantInput.value), quantity, ...(bundleLabel ? { properties: { Bundle: bundleLabel } } : {}) }];
    this.form.querySelectorAll('[data-addon-id]:checked:not(:disabled)').forEach((input) => items.push({ id: Number(input.dataset.addonId), quantity: 1 }));
    try {
      const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items }) });
      const result = await response.json();
      if (!response.ok) throw new Error(result.description || 'We could not add that item. Please try again.');
      const bundleDiscountCode = this.bundleDiscount?.value.trim();
      const root = window.Shopify?.routes?.root || '/';
      if (bundleDiscountCode) {
        const discountResponse = await fetch(`${root}cart/update.js`, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ discount: bundleDiscountCode }) });
        const discountedCart = await discountResponse.json();
        if (!discountResponse.ok) throw new Error(discountedCart.description || 'We could not apply that bundle price. Please try again.');
        document.querySelectorAll('[data-cart-count]').forEach((count) => { count.textContent = discountedCart.item_count; });
        this.status.textContent = 'Added to your cart. Your creepy copilot is ready.';
        window.location.href = `${root}cart`;
        return;
      }
      const cartResponse = await fetch(`${root}cart.js`);
      const cart = await cartResponse.json();
      document.querySelectorAll('[data-cart-count]').forEach((count) => { count.textContent = cart.item_count; });
      this.status.textContent = 'Added to your cart. Your creepy copilot is ready.';
    } catch (error) {
      this.status.classList.add('is-error');
      this.status.textContent = error.message;
    } finally {
      const selected = this.variantSelect?.selectedOptions[0];
      this.button.disabled = selected ? selected.dataset.available !== 'true' : false;
    }
  }
}

customElements.define('product-gallery', ProductGallery);
customElements.define('bundle-picker', BundlePicker);
customElements.define('product-form', ProductForm);
customElements.define('demand-counter', DemandCounter);

const menuButton = document.querySelector('[data-menu-toggle]');
const mobileMenu = document.querySelector('[data-mobile-menu]');
function closeMenu() { if (!menuButton || !mobileMenu) return; mobileMenu.hidden = true; menuButton.setAttribute('aria-expanded', 'false'); }
menuButton?.addEventListener('click', () => { const open = menuButton.getAttribute('aria-expanded') === 'true'; mobileMenu.hidden = open; menuButton.setAttribute('aria-expanded', String(!open)); });
document.addEventListener('keydown', (event) => { if (event.key === 'Escape') closeMenu(); });
